import React from 'react';
import { Table } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import SideNav from '../SideNav';

class MainContract extends React.Component {
    state = {
        data: {},
        loading: false,
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            url: `${API_URL.investigation.queryInvJde}`,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    data: res.data,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
    }, {
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
    }, {
        title: 'JDE主项目号',
        dataIndex: 'jdeCode',
        key: 'jdeCode',
    }, {
        title: '计收入确认方式',
        dataIndex: 'contractTypeName',
        key: 'contractTypeName',
    }]

    getDataSource = () => {
        const { data } = this.state;
        return [{...data}];
    }

    render() {
        const { loading } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='mainContract' />
                <div className="main" style={{ height: 400, paddingTop: 50 }}>
                    <Table
                        loading={loading}
                        pagination={false}
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.investigationId}
                    />
                </div>
            </div>
        );
    }
}

export default MainContract;


// WEBPACK FOOTER //
// ./src/components/projectContract/mainContract/index.js